// @flow
import { Action, ConditionName } from './type'
import { SelectOptions, Conditions } from '../constants/conditions'
import { SortableField } from '../constants/orders'

export type ConditionAction = Action & {
  type:
    | 'CHANGE_KEYWORDS'
    | 'SET_TAGS'
    | 'SET_PAGE'
    | 'RESET_OFFSET'
    | 'CHANGE_PAGE'
    | 'ADD_CONDITION'
    | 'REMOVE_CONDITION'
    | 'TOGGLE_SORT'
    | 'SET_RANGE'
    | 'SET_PERIOD'
    | 'TOGGLE_OPTION'
    | 'SYNC_SELECTED_CONDITION'
    | 'SYNC_SORT_ORDER'
    | 'SET_OPTIONS'
    | 'ADD_TAGS_TO_KEYWORDS'
}

export const CHANGE_KEYWORDS = 'CHANGE_KEYWORDS'
export function changeKeywords(keywords: string) {
  return { type: CHANGE_KEYWORDS, payload: keywords }
}

export const SET_PAGE = 'SET_PAGE'
export function setPage(page: number) {
  return { type: SET_PAGE, payload: page }
}

export const RESET_OFFSET = 'RESET_OFFSET'
export function resetOffset() {
  return { type: RESET_OFFSET, payload: 1 }
}

export const SET_TAGS = 'SET_TAGS'
export function setTags(tags: string) {
  return { type: SET_TAGS, payload: tags }
}

export const ADD_TAGS_TO_KEYWORDS = 'ADD_TAGS_TO_KEYWORDS'
export function addTagsToKeywords(tags: string) {
  return { type: ADD_TAGS_TO_KEYWORDS, payload: tags }
}

export const CHANGE_PAGE = 'CHANGE_PAGE'
export function changePage({ offset, page }: { offset: number; page: number }) {
  return { type: CHANGE_PAGE, payload: { offset, page } }
}

export const ADD_CONDITION = 'ADD_CONDITION'
export function addCondition(name: ConditionName) {
  return { type: ADD_CONDITION, payload: name }
}

export const REMOVE_CONDITION = 'REMOVE_CONDITION'
export function removeCondition(name: ConditionName) {
  return { type: REMOVE_CONDITION, payload: name }
}

export const TOGGLE_SORT = 'TOGGLE_SORT'
export function toggleSort(name: SortableField) {
  return { type: TOGGLE_SORT, payload: name }
}

export type Option = SelectOptions

export const TOGGLE_OPTION = 'TOGGLE_OPTION'
export function toggleOption(name: ConditionName, value: Option) {
  return { type: TOGGLE_OPTION, payload: { name, value } }
}

export const SET_OPTIONS = 'SET_OPTIONS'
export type OptionSetType = 'add' | 'remove'
export function setOptions(
  name: ConditionName,
  values: Option[],
  setType: OptionSetType
) {
  return { type: SET_OPTIONS, payload: { name, values, setType } }
}

export type RangeParams = {
  from?: number | null
  to?: number | null
}

export const SET_RANGE = 'SET_RANGE'
export function setRange(name: ConditionName, range: RangeParams) {
  return { type: SET_RANGE, payload: { name, range } }
}

export type PeriodParams = {
  from?: string | null
  to?: string | null
}

export const SET_PERIOD = 'SET_PERIOD'
export function setPeriod(name: ConditionName, period: PeriodParams) {
  return { type: SET_PERIOD, payload: { name, period } }
}

export const SYNC_SELECTED_CONDITION = 'SYNC_SELECTED_CONDITION'
export function syncSelectedCondition(conditions: Conditions) {
  return { type: SYNC_SELECTED_CONDITION, payload: conditions }
}
export const SYNC_SORT_ORDER = 'SYNC_SORT_ORDER'
export function syncSortOrder({
  offset,
  order,
  sort,
}: {
  offset: any
  order: any
  sort: any
}) {
  return { type: SYNC_SORT_ORDER, payload: { offset, order, sort } }
}

export const SET_STATUS_CONDITION = 'SET_STATUS_CONDITION'
export function setStatus(statusId: string) {
  return { type: SET_STATUS_CONDITION, payload: { statusId: statusId } }
}
